import React from "react";

export default function HumanPotential({ data }) {

  return (
    <>
      <section className="human-potential-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="heading">{data?.head}</h2>
            </div>

            {data?.boxes?.map((item, index) => (
              <div key={index} className="col-lg-6 col-md-6">
                <div className={`human-potential-box ${index===1 ? "human-potential-green" : null}`}>
                  <div><h3 className="heading">{item?.title}</h3></div>
                  <ul>
                    {item?.list?.map((point, ind)=>(
                      <li key={ind}>
                      <span>{point?.label}</span>
                      <p>{point?.desc}</p>
                    </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}